import DeleteIcon from "@mui/icons-material/Delete";
import { Autocomplete, MenuItem, Select, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import { Categorie } from "../../../models/Categorie";
import { Departement } from "../../../models/Departement";
import { Fournisseur } from "../../../models/Fournisseur";
import { Gamme } from "../../../models/Gamme";
import { RequestToSend } from "../../../models/RequestToSend";
import { Selection } from "../../../models/Selection";
import { addRequestToSend } from "../../../redux/features/appStateSlice";
import {
  planoAPI
} from "../../../redux/features/cache";
import { useAppDispatch, useAppSelector } from "../../../redux/store";

export interface ModificationSelectionProps {
  selection: Selection;
}

export const ModificationSelection = (props: ModificationSelectionProps) => {
  const dispatch = useAppDispatch();

  const d_inv026 = useAppSelector((state) => state.appState.d_inv026);

  const [getQueries] = planoAPI.endpoints.getQueries.useLazyQuery();
  const [updateSelection] = planoAPI.endpoints.updateSelection.useMutation();
  const [deleteSelection] = planoAPI.endpoints.deleteSelection.useMutation();

  const [isDirty, setIsDirty] = useState<boolean>(false);

  const [departments, setDepartments] = useState<Departement[]>([]);
  const [suppliers, setSuppliers] = useState<Fournisseur[]>([]);
  const [productRange, setProductRange] = useState<Gamme[]>([]);
  const [categories, setCategories] = useState<Categorie[]>([]);

  const [defaultCategory, setDefaultCategory] = useState<Categorie | null>(props.selection.categorie);
  const [defaultDepartment, setDefaultDepartment] = useState<Departement | null>(props.selection.departement);
  const [defaultSupplier, setDefaultSupplier] = useState<Fournisseur | null>(props.selection.fournisseur);
  const [defaultProductRange, setDefaultProductRange] = useState<Gamme | null>(props.selection.gamme);

  const [mode, setMode] = useState<boolean>(props.selection.planss_mode);

  useEffect(() => {
    setIsDirty(false);
  }, [props.selection]);

  const handleDelete = async () => {
    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Supprimer sélection pour section ${props.selection.plans_seq}`,
          deleteSelection,
          () => { },
          {},
          {
            plans_seq: props.selection.plans_seq,
            planss_seq: props.selection.planss_seq,
          },
          []
        )
      )
    );
  };

  const handleSubmit = async () => {
    let data = {
      planss_mode: mode,
      planss_seq: props.selection.planss_seq,
    };
    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Modifier sélection ${props.selection.plans_seq}`,
          updateSelection,
          () => { },
          {},
          data,
          []
        )
      )
    );
  };

  const getAutocomplete = async (
    event: any,
    queries: string,
    setState: any
  ) => {
    if (event !== null) {
      let rech = event.target.value;
      if (rech) {
        let result = await getQueries(
          { queries, rech, treeView: false },
          true
        ).unwrap();
        setState(result);
      } else {
        setState([]);
      }
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <TextField
        select
        label="Mode"
        sx={{ width: "7vw", p: 1, mr: 3 }}
        onChange={(e) => {
          console.log(e.target);
          setIsDirty(true);
          setMode(e.target.value === "inclus");	
        }}
        value={mode ? "inclus" : "exclus"}
      >
        <MenuItem value="inclus">Inclus</MenuItem>
        <MenuItem value="exclus">Exclus</MenuItem>
      </TextField>
      <Autocomplete
        options={departments}
        clearOnBlur={false}
        disabled
        defaultValue={defaultDepartment}
        getOptionLabel={(cat) => `${cat.dept_cd} ${cat.dept_nom}`}
        onChange={(e, data) => {
          setIsDirty(true);
          setDefaultDepartment(data);
        }}
        onInputChange={(event) => {
          getAutocomplete(event, "departement", setDepartments);
        }}
        sx={{ width: "15vw", p: 1 }}
        renderInput={(params) => (
          <TextField
            sx={{
              color: "red",
            }}
            {...params}
            label="Departement"
          />
        )}
      />
      <Autocomplete
        options={categories}
        disabled
        clearOnBlur={false}
        getOptionLabel={(cat) => `${cat.cat_cd} ${cat.cat_descr}`}
        value={defaultCategory}
        onChange={(e, data) => {
          setIsDirty(true);
          setDefaultCategory(data);
        }}
        onInputChange={(event) => {
          getAutocomplete(event, "categories", setCategories);
        }}
        sx={{ width: "15vw", p: 1 }}
        renderInput={(params) => <TextField {...params} label="Categories" />}
      />
      <Autocomplete
        options={suppliers}
        disabled
        clearOnBlur={false}
        value={defaultSupplier}
        getOptionLabel={(cat) => `${cat.four_cd} ${cat.four_nom}`}
        onChange={(e, data) => {
          setIsDirty(true);
          setDefaultSupplier(data);
        }}
        onInputChange={(event) => {
          getAutocomplete(event, "fournisseur", setSuppliers);
        }}
        sx={{ width: "15vw", p: 1 }}
        renderInput={(params) => <TextField {...params} label="Fournisseur" />}
      />
      <Autocomplete
        options={productRange}
        disabled
        clearOnBlur={false}
        value={defaultProductRange}
        getOptionLabel={(cat) => `${cat.gamme_cd} ${cat.gamme_descr}`}
        onChange={(e, data) => {
          setIsDirty(true);
          setDefaultProductRange(data);
        }}
        onInputChange={(event) => {
          getAutocomplete(event, "gamme", setProductRange);
        }}
        sx={{ width: "15vw", p: 1 }}
        renderInput={(params) => <TextField {...params} label="Gamme" />}
      />
      <Tooltip title="Enregistrer">
        <span
          style={{
            display: "flex",
            alignItems: "center",
            padding: "6px 28px",
            cursor: "pointer",
          }}
          className={`save-wrapper ${!isDirty ? "custom-disabled" : ""}`}
        >
          <span
            className={`k-icon k-font-icon k-i-save k-icon-xl`}
            onClick={handleSubmit}
          ></span>
        </span>
      </Tooltip>
      <Tooltip title="Effacer">
        <span>
          <Button
            color="error"
            disabled={!d_inv026.canDelete}
            onClick={handleDelete}
          >
            {" "}
            <DeleteIcon />
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
}
